import { state } from '../state.js';
import { $ } from '../utils/dom.js';
import { fmtMoney, fmtInt } from '../utils/format.js';
import { montoDisplay } from '../utils/currency.js';

export function renderKPIs() {
  const rows = state.filtered;
  const totalCount = rows.length;
  const withAmount = rows.filter((r) => r.MONTO > 0);
  const total = withAmount.reduce((s, r) => s + montoDisplay(r), 0);
  const avg = withAmount.length ? total / withAmount.length : 0;
  const unique = new Set(rows.map((r) => (r.EMAIL || r.NOMBRE || '').toLowerCase()).filter(Boolean)).size;

  $('kpiCount').textContent = fmtInt(totalCount);
  $('kpiCountSub').textContent = `${withAmount.length} con monto · ${totalCount - withAmount.length} sin monto`;
  $('kpiTotal').textContent = fmtMoney(total);
  $('kpiTotalSub').textContent = `de ${state.rows.length} registros totales`;
  $('kpiAvg').textContent = fmtMoney(avg);
  $('kpiUnique').textContent = fmtInt(unique);
}
